var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',[_c('v-pagination',{attrs:{"value":_vm.page,"length":_vm.length,"total-visible":7},on:{"input":_vm.changePage}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }